module.exports = __webpack_public_path__ + "static/media/shopify_glyph_black.ffcfc4ec.svg";